import { motion } from 'framer-motion';
import { FC, ReactNode } from 'react';

type StaggerItemProps = {
  children: ReactNode;
  className?: string;
};

export const StaggerItem: FC<StaggerItemProps> = ({ children, className }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y: 10 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.3, ease: 'easeOut' } },
    }}
  >
    {children}
  </motion.div>
);
